import React, { useEffect } from "react";
import AOS from "aos";
import { FaGraduationCap, FaCalendarAlt, FaGlobe, FaFileAlt } from "react-icons/fa";
import "aos/dist/aos.css";
import "./eligibility-criteria.css";

const eligibilityData = [
  {
    icon: <FaGraduationCap />,
    title: "Education",
    desc: "Graduate in any discipline from a university recognized by the relevant authority.",
  },
{
  icon: <FaCalendarAlt />,
  title: "Age Limit",
  desc: "you must be at least 21 years old. Additional terms may apply.",
},

  {
    icon: <FaGlobe />,
    title: "Nationality",
    desc: "Applicant must be an Indian citizen in accordance with government norms. ",
  },
  {
    icon: <FaFileAlt />,
    title: "Other Conditions",
    desc: "Medical fitness certificate required. Additional documents may be requested as per ",
  },
];

export default function EligibilityCriteria() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="ec-section py-5 mt-5">
      <div className="container text-center">
        <h2 className="ec-section__title" data-aos="fade-up">
          Eligibility Criteria
        </h2>
        <p className="ec-section__subtitle mb-5" data-aos="fade-up">
        Check if you meet the necessary qualifications before applying:
        </p>

        <div className="row g-4 justify-content-center">
          {eligibilityData.map((item, idx) => (
            <div
              className="col-md-6 col-lg-3"
              key={idx}
              data-aos="zoom-in"
              data-aos-delay={idx * 150}
            >
              <div className="ec-card h-100">
                <div className="ec-card__icon">{item.icon}</div>
                <h5 className="ec-card__title">{item.title}</h5>
                <p className="ec-card__desc">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
